import { tierFromPlanKey } from '../lib/stripe-config'
import type { TestingScheduleInput } from '../schemas/testingSchedules'

// Plan suggestions are presentation only; persisted schedules contain numeric budgets.
export function onboardingScheduleChoices(planKey: string | null | undefined) {
  const tier = tierFromPlanKey(planKey)
  const pro = ['team', 'growth', 'enterprise', 'private-cloud', 'on-prem'].includes(tier)
  const free = !pro && tier !== 'individual'
  const options = [
    { id: 'daily', label: 'Daily', disabled: free, cadence: 'daily' as const, budget: pro ? 25 : 1 },
    { id: 'weekly', label: 'Weekly', disabled: false, cadence: 'weekly' as const, budget: pro ? 25 : free ? 1 : 5 },
  ]
  return options.map(option => ({
    ...option,
    journeys: option.budget * 2,
    description: `${option.budget * 2} journeys each time`,
    schedule: {
      name: 'Regular testing', enabled: true, cadence: option.cadence, budget: option.budget,
      hour: 21, minute: 0, weekday: 0, month_day: 1,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, monthly_budget: null,
      target: { kind: 'journeys', journey_ids: null, environment_id: null },
    } satisfies TestingScheduleInput,
  }))
}

export function defaultInitialJourneys(planKey: string | null | undefined, availableCredits?: number): number | null {
  const tier = tierFromPlanKey(planKey)
  const preferred = !tier || tier === 'free' ? 10 : 50
  return [50, 10, 2].find(journeys => journeys <= preferred &&
    (availableCredits === undefined || 1 + journeys / 2 <= availableCredits)) ?? null
}
